var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgSignupIcon = function SvgSignupIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0389,
    cy: 34.9022,
    r: 34.5193,
    fill: "#DFE0E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7984 21.9417C39.4864 20.5252 37.6539 19.7451 35.6313 19.7451C33.5979 19.7451 31.7593 20.5205 30.4534 21.9282C29.1333 23.3514 28.4901 25.2857 28.6411 27.3744C28.9405 31.4952 32.0762 34.8473 35.6313 34.8473C39.1864 34.8473 42.3167 31.4959 42.6208 27.3758C42.7738 25.306 42.1266 23.3757 40.7984 21.9417ZM47.4973 49.9495H23.7653C23.4546 49.9536 23.147 49.8883 22.8648 49.7585C22.5825 49.6287 22.3328 49.4376 22.1337 49.1991C21.6955 48.6753 21.5188 47.96 21.6496 47.2365C22.2186 44.0799 23.9945 41.4283 26.7857 39.5668C29.2654 37.9143 32.4066 37.0048 35.6313 37.0048C38.856 37.0048 41.9971 37.915 44.4769 39.5668C47.2681 41.4276 49.0439 44.0792 49.613 47.2359C49.7438 47.9593 49.5671 48.6746 49.1289 49.1985C48.9299 49.4371 48.6801 49.6283 48.3979 49.7582C48.1157 49.8881 47.808 49.9535 47.4973 49.9495Z",
    fill: "#444554"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSignupIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/signupIcon.5f0f4612a37b90997ba8769e5c138ddf.svg";